import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.less';

const AddCardIcon = ({ className }) => (
  <svg
    width="45"
    height="39"
    fill="none"
    className={classNames(styles.cardIcon, className)}
  >
    <path d="M31.686 15.825a2.188 2.188 0 0 0-2.161-2.207h-1.812l.347-1.783a2.208 2.208 0 0 0-1.695-2.588L7.135 5.303a2.119 2.119 0 0 0-1.615.318 2.192 2.192 0 0 0-.938 1.413L2.35 18.51a2.208 2.208 0 0 0 1.7 2.59l3.703.761v5.672a2.185 2.185 0 0 0 2.16 2.207h12.562a.531.531 0 0 0 0-1.063H9.907a1.123 1.123 0 0 1-1.098-1.144v-8.438h21.816v8.258c0 .98-.336 1.327-1.283 1.327H26.6a.532.532 0 0 0 0 1.062h2.747a2.124 2.124 0 0 0 2.345-2.39l-.006-11.526ZM4.259 20.06a1.142 1.142 0 0 1-.867-1.345l2.23-11.476a1.136 1.136 0 0 1 .487-.736 1.062 1.062 0 0 1 .812-.16L21.533 9.35l1.231.243 3.386.696a1.142 1.142 0 0 1 .867 1.345l-.388 1.988h-2.62l-14.102-.06a2.245 2.245 0 0 0-2.16 2.267v4.949l-3.488-.718Zm4.55-2.029V15.83a1.185 1.185 0 0 1 1.096-1.204l14.909.066h1.234v-.007h3.482a1.124 1.124 0 0 1 1.099 1.145v2.202H8.809Z" />
    <path d="M11.427 25.291a.53.53 0 1 0 0 1.063h6.731a.531.531 0 0 0 0-1.063h-6.73Z" />
    <circle cx="35.5" cy="29" r="9" stroke="#005FB9" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      d="M30.5 28.923h10M35.577 24v10"
    />
  </svg>
);

AddCardIcon.propTypes = {
  className: PropTypes.string,
};

export default AddCardIcon;
